import { useCallback, useRef, useState } from 'react';
import { Button } from '@mui/material';
import { HexColorInput, HexColorPicker } from 'react-colorful';
import useClickOutside from '@/hooks/useClickOutside';

export const ColorPickerPopover = ({
  color,
  onChange,
  onClose,
}: {
  color: string;
  onChange: (newColor: string) => void;
  onClose?: () => void;
}) => {
  const popover = useRef();
  const [isOpen, toggle] = useState(false);

  const close = useCallback(() => {
    onClose && onClose();
    toggle(false);
  }, [onClose]);
  useClickOutside(popover, close);

  return (
    <div className={'picker'}>
      <Button className="swatch" style={{ backgroundColor: color }} onClick={() => toggle(true)}>
        {color}
      </Button>

      {isOpen && (
        <div style={{ position: 'absolute', zIndex: 1000, display: 'flex', flexDirection: 'column' }} ref={popover}>
          <HexColorInput color={color} onChange={onChange} />
          <HexColorPicker color={color} onChange={onChange} />
        </div>
      )}
    </div>
  );
};
